import * as actions from './relatorio.action';
import inicialState from './relatorio.state';

const relatoriosReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.RELATORIO_LAUDO_SELECIONADO:
      return {
        ...state,
        laudoSelecionado: action.payload.laudoSelecionado
      };

    default:
      return state;
  }
};

export default relatoriosReducer;



// WEBPACK FOOTER //
// ./src/pages/relatorio/relatorio.reducer.js